<template>
  <div class="">
    <div class="bgImage">
      <div class="row">
        <div class="col-12">
          <div class="div-colab">
            <router-link to="/collaboration">
              <img src="img/icons/NewButtonIcons/btn_collab.png" class="categoryImage" title="Collaboration">
            </router-link>
          </div>
          <div class="div-innovation">
            <router-link to="/innovation">
              <img src="img/icons/NewButtonIcons/btn_innovation.png" class="categoryImage" title="Innovation">
            </router-link>
          </div>
          <div class="div-report">
            <router-link to="/reporting">
              <img src="img/icons/NewButtonIcons/btn_reporting.png" class="categoryImage" title="Reporting">
            </router-link>
          </div>
          <div class="div-design">
            <router-link to="/design">
              <img src="img/icons/NewButtonIcons/btn_design.png" class="categoryImage" title="Design">
            </router-link>
          </div>
          <div class="div-management">
            <router-link to="/management">
              <img src="img/icons/NewButtonIcons/btn_management.png" class="categoryImage" title="Management">
            </router-link>
          </div>
          <div class="div-commercial">
            <router-link to="/commercial">
              <img src="img/icons/NewButtonIcons/btn_commercial.png" class="categoryImage" title="Commercial">
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bg_gradient row">
    </div> -->
  </div>

</template>

<script>
// import VueFrame from 'vue-frame'
export default {
  name: 'LandingPageNew',
  components: {
    // VueFrame
  },
  data() {
    return {
      links: {
        collab: ""
      },
      accessToken: ""
    }
  },
}
</script>

<style scoped>

.div-colab {
  top: 88px;
  position: absolute;
  z-index: 1;
  left: 1235px;
}
.div-innovation {
  top: 485px;
  position: absolute;
  z-index: 1;
  left: 837px;
}
.div-report {
  z-index: 10;
  position: absolute;
  top: 485px;
  left: 1234px;
}
.div-design {
  z-index: 10;
  position: absolute;
  top: 294px;
  left: 1437px;
}
.div-management {
  z-index: 10;
  position: absolute;
  top: 89px;
  left: 830px;
}
.div-commercial {
  z-index: 10;
  position: absolute;
  top: 293px;
  left: 633px;
}
</style>
